import { Col, Form, Input, InputNumber, Row } from "antd";
import { useEffect } from "react";
import { useIntl } from "react-intl";

const AddEndEditPoolForm = ({ handleSetFormRef, pool }) => {
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const initValues = {
    ...pool,
  };

  useEffect(() => {
    handleSetFormRef(form);
  }, []);

  return (
    <Form
      form={form}
      labelCol={{
        span: 9,
      }}
      colon={false}
      labelWrap={true}
      initialValues={initValues}
    >
      <Row>
        <Col span={13}>
          <Form.Item
            required={true}
            name={"nameLocal"}
            label={formatMessage({
              id: "name.local",
              defaultMessage: "Local Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.local.name.item",
                defaultMessage: "The name of the {item} in the local Language",
              },
              {
                item: formatMessage({
                  id: "pool",
                  defaultMessage: "Pool",
                }),
              },
            )}
            rules={[
              {
                required: true,
                message: "Please input Local Name",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10} offset={1}>
          <Form.Item
            labelCol={{
              span: 10,
            }}
            name={"abbreviationLocal"}
            label={formatMessage({
              id: "name.local.abbreviation",
              defaultMessage: "Local Abbr",
            })}
            tooltip={formatMessage({
              id: "form.help.local.abbreviation",
              defaultMessage: "An abbreviation/short name in the local language",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={13}>
          <Form.Item
            name={"nameLatin"}
            label={formatMessage({
              id: "name.latin",
              defaultMessage: "Latin Name",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.latin.name.item",
                defaultMessage: "The name of the {item} in latin characters",
              },
              {
                item: formatMessage({
                  id: "pool",
                  defaultMessage: "Pool",
                }),
              },
            )}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10} offset={1}>
          <Form.Item
            labelCol={{
              span: 10,
            }}
            name={"abbreviationLatin"}
            label={formatMessage({
              id: "name.latin.abbreviation",
              defaultMessage: "Latin Abbr",
            })}
            tooltip={formatMessage({
              id: "form.help.latin.abbreviation",
              defaultMessage: "An abbreviation/short name in latin characters",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={13}>
          <Form.Item
            name={"externalId"}
            label={formatMessage({
              id: "externalId",
              defaultMessage: "External Id",
            })}
            tooltip={formatMessage({
              id: "externalId",
              defaultMessage: "External Id",
            })}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={10} offset={1}>
          <Form.Item
            labelCol={{
              span: 11,
            }}
            required={true}
            name={"poolOrder"}
            label={formatMessage({
              id: "pool.order",
              defaultMessage: "Pool Order",
            })}
            tooltip={formatMessage(
              {
                id: "form.help.order.different.within.itemA.itemB",
                defaultMessage: "The order of the different {itemA} within a {itemB}",
              },
              {
                itemA: formatMessage({
                  id: "pools",
                  defaultMessage: "Pools",
                }),
                itemB: formatMessage({
                  id: "season",
                  defaultMessage: "Season",
                }),
              },
            )}
            rules={[
              {
                required: true,
                message: "Please input Pool Order",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Form.Item name={"poolCode"} hidden={true} />
      </Row>
    </Form>
  );
};

export default AddEndEditPoolForm;
